import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { DEFAULT_CONTENT } from "../data/site";
import { API } from "../data/api";

const ContentContext = createContext({
  content: DEFAULT_CONTENT,
  loading: true,
  refresh: async () => {},
  applyContent: () => {},
});

export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${API}/content`, { cache: "no-store" });
      if (res.ok) {
        const data = await res.json();
        setContent({ ...DEFAULT_CONTENT, ...data });
      }
    } catch {
      /* keep defaults on network error */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Let the admin push a freshly-saved content object without a round-trip.
  const applyContent = useCallback((data) => {
    setContent({ ...DEFAULT_CONTENT, ...data });
  }, []);

  return (
    <ContentContext.Provider value={{ content, loading, refresh, applyContent }}>
      {children}
    </ContentContext.Provider>
  );
}
